import * as Yup from "yup";

export const tripSchema = Yup.object().shape({
    fecha_inicio: Yup.date()
      .required("Este campo es obligatorio")
      .typeError("Este campo es obligatorio"),
  });